<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: "App",
		watch: {
			$route(to, from) {
				if (to.path != '/login') {
					let obj = {
						name: to.name,
						title: to.meta.title
					}
					this.$store.commit("addTab", obj)
				}
			}
		}
	}
</script>

<style>
  html, body, #app {
    font-family: 'Helvetica Neue', 'Hiragino Sans GB', 'WenQuanYi Micro Hei', 'Microsoft Yahei', sans-serif;
    height: 100%;
    padding: 0;
    margin: 0;
    font-size: 15px;
  }
  :root {
    --brand-primary: #2e7ae5;
    --brand-accent: #5bbcff;
    --brand-dark: #0b5cad;
    --text-color: #1f2d3d;
    --bg-light: #f5f9ff;
    --bg-soft: #f0f6ff;
  }
  body {
    background: var(--bg-light);
    color: var(--text-color);
  }
  .el-button--primary {
    background-color: var(--brand-primary);
    border-color: var(--brand-primary);
  }
  .el-button--primary:hover,
  .el-button--primary:focus {
    background-color: var(--brand-accent);
    border-color: var(--brand-accent);
  }
  .el-link--primary {
    color: var(--brand-primary);
  }
  /* 仅为下划线高亮保留主色背景 */
  .el-tabs__active-bar {
    background-color: var(--brand-primary);
  }
  /* 选中标签的文字采用主色，避免背景遮挡文字 */
  .el-tabs__item.is-active {
    color: var(--brand-primary);
    background-color: transparent;
  }
  /* 卡片风格下，选中项保持白底与主色文字，避免蓝底覆盖标题 */
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #fff;
    border-bottom-color: #fff;
    color: var(--brand-primary);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue